import { useRef } from 'react';
import s from './CodeInput.module.css';

interface CodeInputProps {
  length?: number;
  value: string;
  onChange: (next: string) => void;
  onComplete?: () => void;
  autoFocus?: boolean;
  disabled?: boolean;
}

export function CodeInput({
  length = 6,
  value,
  onChange,
  onComplete,
  autoFocus = true,
  disabled = false,
}: CodeInputProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const filtered = e.target.value
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, '')
      .slice(0, length);
    onChange(filtered);
    if (filtered.length === length) {
      onComplete?.();
    }
  };

  const cells = Array.from({ length }, (_, i) => {
    const char = value[i] ?? '';
    const isActive = i === value.length && !disabled;
    return (
      <div
        key={i}
        className={`${s.cell} ${isActive ? s.cellActive : ''} ${char ? s.cellFilled : ''}`}
      >
        {char || (isActive ? <span className={s.caret} /> : null)}
      </div>
    );
  });

  return (
    <div className={s.root} onClick={() => inputRef.current?.focus()}>
      <div className={s.cells}>{cells}</div>
      <input
        ref={inputRef}
        className={s.hiddenInput}
        type="text"
        inputMode="text"
        autoCapitalize="characters"
        autoComplete="one-time-code"
        autoCorrect="off"
        spellCheck={false}
        maxLength={length}
        value={value}
        onChange={handleChange}
        autoFocus={autoFocus}
        disabled={disabled}
        aria-label="Код комнаты"
      />
    </div>
  );
}
